"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var AutomationsSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M12.4999292,3 L7.5,3 C7.2847848,3 7.09371537,3.13771505 7.02565835,3.34188612 L5.02565835,9.34188612 C4.93833446,9.60385778 5,10 5.5,10 L6.805,10 L5.02518482,15.3423554 C4.88677979,15.7162628 5.32061768,16.233078 5.8288046,15.8766801 C5.8288046,15.8766801 8.4956205,13.5432162 13.8292523,8.87628835 C14.1575353,8.60655349 14.0078368,8.00235988 13.5,8 L11.238,8 L12.964151,3.68573668 C13.0667305,3.42935405 13,3 12.4999292,3 Z M7.86,4 L11.761,4 L9.76148352,9 L12.168,9 L6.557,13.91 L8.19371294,9 L6.193,9 L7.86,4 Z" })));
};
AutomationsSmall.displayName = 'AutomationsSmall';
exports.default = AutomationsSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=AutomationsSmall.js.map